// Phone: strips non-digits and formats as (xxx)-xxx-xxxx
export function formatPhone(raw) {
  const digits = raw.replace(/\D/g, '').slice(0, 10)
  if (!digits) return ''
  if (digits.length <= 3) return `(${digits}`
  if (digits.length <= 6) return `(${digits.slice(0, 3)})-${digits.slice(3)}`
  return `(${digits.slice(0, 3)})-${digits.slice(3, 6)}-${digits.slice(6)}`
}

export function isValidPhone(value) {
  return /^\(\d{3}\)-\d{3}-\d{4}$/.test(value)
}

export function isValidEmail(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((value ?? '').trim())
}

// Password policy: 8+ characters, at least 1 number, at least 1 special character.
export function isValidPassword(value) {
  const v = value ?? ''
  return v.length >= 8 && /\d/.test(v) && /[^A-Za-z0-9]/.test(v)
}
